var Component = require("!../../../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../vue-loader/lib/selector?type=script&index=0!./menu-item.vue"),
  /* template */
  require("!!../../../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-65d3fef9\"}!../../../../../../vue-loader/lib/selector?type=template&index=0!./menu-item.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/vue-xpc/src/element-ui/packages/menu/src/menu-item.vue
// module id = 1982
// module chunks = 228